module.exports = __webpack_public_path__ + "img/10.ebc72ea7.svg";